import { Component, OnInit } from '@angular/core';
import { GestionProvenanceService } from '../../services/navigation/gestion-provenance.service';

@Component({
  selector: 'app-bouton-retour',
  templateUrl: './bouton-retour.component.html',
  standalone: false,
})
export class BoutonRetourComponent implements OnInit {
  estProvenanceExterne: boolean;

  constructor(private readonly gestionProvenanceService: GestionProvenanceService) {}

  ngOnInit() {
    this.estProvenanceExterne = this.gestionProvenanceService.estProvenanceExterne();
  }
}
